import styled from 'styled-components'
import { Spacings, Text } from '@styles'
import { Button } from '@baseV2'

/*
 * The Serviced Quantity tab reuses the card chrome already built for the Basic
 * Details tab so the two tabs stay visually identical. Shared primitives are
 * re-exported from the sibling style module; only the table + charges specific
 * pieces are defined here.
 */
export {
	BasicDetailsCard,
	CardHeader,
	CardTitle,
	HeaderRight,
	EditBtn,
	ChevronBtn,
	VehicleInputSection,
	VehicleInputGroup,
	VehicleInputLabel,
	SectionDivider,
	IconActionBtn,
} from '../BasicDetails/style'

export const UpdateBtn = styled(Button)`
	
`
export const AddBtn  = styled(Button).attrs({ variant: 'outline', color: 'primary' })`
	white-space: nowrap;
	padding-top: ${Spacings.SPACING_2B};
	padding-bottom: ${Spacings.SPACING_2B};
	font-size: ${Text.MEDIUM};
`
// Input cells align to the top so an error under one input doesn't push the other input down.
export const ServicedTableWrapper = styled.div`
	td:not(:first-child) {
		vertical-align: top;
	}
`

export const CardsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

/* ---- Other Charges list ---- */

export const ChargesList = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

export const ChargeRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
	border: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
	border-radius: ${Spacings.SPACING_5};
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
`

export const ChargeLabel = styled.span`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.palette.text.blackGrey};
`

export const ChargeAmount = styled.span`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.palette.text.blackGrey};
	margin-left: auto;
	margin-right: ${Spacings.SPACING_4B};
`
